import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';

import cls from 'classnames/bind';

import noop from 'lodash/noop';

import Arrow from '@ott/icon-select-arrow';

import CYIcon from '../../flags/CYIcon';
import GRIcon from '../../flags/GRIcon';
import INIcon from '../../flags/INIcon';
import RUIcon from '../../flags/RUIcon';
import THIcon from '../../flags/THIcon';
import TRIcon from '../../flags/TRIcon';
import UAEIcon from '../../flags/UAEIcon';
import CountriesOverlay from './CountriesOverlay/CountriesOverlay';

import styles from './PriceCountries.scss';

const cx = cls.bind(styles);

const COUNTRIES = [
  {
    id: 298795,
    name: 'Турция',
    Icon: TRIcon,
  },
  {
    id: 2017370,
    name: 'Россия',
    Icon: RUIcon,
  },
  {
    id: 1605651,
    name: 'Таиланд',
    Icon: THIcon,
  },
  {
    id: 146669,
    name: 'Кипр',
    Icon: CYIcon,
  },
  {
    id: 390903,
    name: 'Греция',
    Icon: GRIcon,
  },
  {
    id: 1269750,
    name: 'Индия',
    Icon: INIcon,
  },
  {
    id: 290557,
    name: 'ОАЭ',
    Icon: UAEIcon,
  },
];

// max 5
const TOP_COUNTRIES_IDS = [298795, 2017370, 1605651, 146669, 390903];

const TOP_COUNTRIES = [];
const REST_COUNTRIES = [];
COUNTRIES.forEach((country) => {
  if (TOP_COUNTRIES_IDS.includes(country.id) && TOP_COUNTRIES.length < 5) {
    TOP_COUNTRIES.push(country);
  } else {
    REST_COUNTRIES.push(country);
  }
});

// todo sort alphabetically?
// todo sort by priority

class PriceCountries extends PureComponent {
  static propTypes = {
    toCountryId: PropTypes.number,
    onCountryChange: PropTypes.func,
  };

  static defaultProps = {
    onCountryChange: noop,
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.restCountriesRef = React.createRef();

    this.state = {
      showRestCountriesOverlay: false,
    };
  }

  handleCountryChange = (countryId) => {
    this.props.onCountryChange(countryId);
  };

  renderTopCountries() {
    const { toCountryId } = this.props;

    return TOP_COUNTRIES.map(({ id, name, Icon }, i) => {
      return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          className={cx('country', {
            'country--isActive': id === toCountryId,
            'country--noRestCountriesSibling': REST_COUNTRIES.length === 0,
          })}
          onClick={this.handleCountryChange.bind(this, id)}
          // eslint-disable-next-line react/no-array-index-key
          key={i}
        >
          <Icon className={cx('country-icon')} />
          <div className={cx('country-name')}>{name}</div>
        </div>
      );
    });
  }

  toggleRestCountries = () => {
    const { showRestCountriesOverlay } = this.state;
    this.setState({
      showRestCountriesOverlay: !showRestCountriesOverlay,
    });
  };

  hideRestCountries = () => this.setState({ showRestCountriesOverlay: false });

  renderRestCountriesOverlay() {
    const { showRestCountriesOverlay } = this.state;
    const { toCountryId } = this.props;

    return (
      <CountriesOverlay
        isOpen={showRestCountriesOverlay}
        toCountryId={toCountryId}
        countries={REST_COUNTRIES}
        parentRef={this.restCountriesRef}
        onCountryChange={this.handleCountryChange}
        onHide={this.hideRestCountries}
      />
    );
  }

  renderRestCountries() {
    if (REST_COUNTRIES.length === 0) {
      return null;
    }

    const { showRestCountriesOverlay } = this.state;
    const { toCountryId } = this.props;

    const activeRestCountry = REST_COUNTRIES.find((country) => country.id === toCountryId);

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={cx('country', 'country--isRest', {
          'country--isActive': activeRestCountry,
          'country--isOpen': showRestCountriesOverlay,
        })}
        onClick={this.toggleRestCountries}
        key="restCountries"
        ref={this.restCountriesRef}
      >
        {activeRestCountry ? (
          <>
            <activeRestCountry.Icon className={cx('country-icon')} />
            <div className={cx('country-name')}>{activeRestCountry.name}</div>
            <Arrow w={11} className={cx('country-arrow')} />
          </>
        ) : (
          <>
            <div className={cx('country-name')}>Ещё страны</div>
            <Arrow w={11} className={cx('country-arrow')} />
          </>
        )}

        {this.renderRestCountriesOverlay()}
      </div>
    );
  }

  render() {
    return (
      // eslint-disable-next-line no-return-assign,react/no-unused-class-component-methods
      <div className={cx('PriceCountries')} ref={(ref) => (this.rootRef = ref)}>
        {this.renderTopCountries()}
        {this.renderRestCountries()}
      </div>
    );
  }
}

export default PriceCountries;
